import React, { createRef, useState } from 'react';
import "./newhotel.scss"; // ← same shared stylesheet
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { hotelInputs } from "../../formSource";
import axios from 'axios';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from "react-router-dom";
import Dropzone from 'react-dropzone';
// ── Food & Drink ──────────────────────────────────────────────────────────────
import LocalCafeIcon from '@mui/icons-material/LocalCafe';
import BrunchDiningIcon from '@mui/icons-material/BrunchDining';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import KitchenIcon from '@mui/icons-material/Kitchen';
import GrassIcon from '@mui/icons-material/Grass';
import NoMealsIcon from '@mui/icons-material/NoMeals';
import SpaIcon from '@mui/icons-material/Spa';
import EmojiFoodBeverageIcon from '@mui/icons-material/EmojiFoodBeverage';
import SetMealIcon from '@mui/icons-material/SetMeal';
import RamenDiningIcon from '@mui/icons-material/RamenDining';
import LunchDiningIcon from '@mui/icons-material/LunchDining';
import DinnerDiningIcon from '@mui/icons-material/DinnerDining';
import IcecreamIcon from '@mui/icons-material/Icecream';
import LocalBarIcon from '@mui/icons-material/LocalBar';
import LocalPizzaIcon from '@mui/icons-material/LocalPizza';
import BakeryDiningIcon from '@mui/icons-material/BakeryDining';
import TapasIcon from '@mui/icons-material/Tapas';
import FreeBreakfastIcon from '@mui/icons-material/FreeBreakfast';
// ── Amenities & Comfort ───────────────────────────────────────────────────────
import WifiIcon from '@mui/icons-material/Wifi';
import TvIcon from '@mui/icons-material/Tv';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import FireplaceIcon from '@mui/icons-material/Fireplace';
import DeckIcon from '@mui/icons-material/Deck';
import WavesIcon from '@mui/icons-material/Waves';
import LandscapeIcon from '@mui/icons-material/Landscape';
import PoolIcon from '@mui/icons-material/Pool';
import HotTubIcon from '@mui/icons-material/HotTub';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import CabinIcon from '@mui/icons-material/Cabin';
import BalconyIcon from '@mui/icons-material/Balcony';
import YardIcon from '@mui/icons-material/Yard';
import OutdoorGrillIcon from '@mui/icons-material/OutdoorGrill';
// ── Services ──────────────────────────────────────────────────────────────────
import RoomServiceIcon from '@mui/icons-material/RoomService';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import LocalPlayIcon from '@mui/icons-material/LocalPlay';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import IronIcon from '@mui/icons-material/Iron';
import LocalLaundryServiceIcon from '@mui/icons-material/LocalLaundryService';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement';
// ── Transport & Access ────────────────────────────────────────────────────────
import LocalParkingIcon from '@mui/icons-material/LocalParking';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import AccessibleIcon from '@mui/icons-material/Accessible';
import SmokeFreeIcon from '@mui/icons-material/SmokeFree';
import SmokingRoomsIcon from '@mui/icons-material/SmokingRooms';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import ElectricCarIcon from '@mui/icons-material/ElectricCar';
import TwoWheelerIcon from '@mui/icons-material/TwoWheeler';
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
// ── Entertainment ─────────────────────────────────────────────────────────────
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import PianoIcon from '@mui/icons-material/Piano';
import CasinoIcon from '@mui/icons-material/Casino';
import SportsBarIcon from '@mui/icons-material/SportsBar';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import GolfCourseIcon from '@mui/icons-material/GolfCourse';
import FestivalIcon from '@mui/icons-material/Festival';
import CelebrationIcon from '@mui/icons-material/Celebration';
// ── People & Family ───────────────────────────────────────────────────────────
import ChildCareIcon from '@mui/icons-material/ChildCare';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import PetsIcon from '@mui/icons-material/Pets';
import ElderlyIcon from '@mui/icons-material/Elderly';
import GroupsIcon from '@mui/icons-material/Groups';
// ── Hotel Specific ────────────────────────────────────────────────────────────
import HotelIcon from '@mui/icons-material/Hotel';
import KingBedIcon from '@mui/icons-material/KingBed';
import BathtubIcon from '@mui/icons-material/Bathtub';
import ShowerIcon from '@mui/icons-material/Shower';
import ElevatorIcon from '@mui/icons-material/Elevator';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import LuggageIcon from '@mui/icons-material/Luggage';
import NightlightIcon from '@mui/icons-material/Nightlight';
import SecurityIcon from '@mui/icons-material/Security';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import LockIcon from '@mui/icons-material/Lock';
import AlarmIcon from '@mui/icons-material/Alarm';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import FollowTheSignsIcon from '@mui/icons-material/FollowTheSigns';
// ── General ───────────────────────────────────────────────────────────────────
import StarIcon from '@mui/icons-material/Star';
import VerifiedIcon from '@mui/icons-material/Verified';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import PublicIcon from '@mui/icons-material/Public';
import LanguageIcon from '@mui/icons-material/Language';
import Brightness3Icon from '@mui/icons-material/Brightness3';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

// ─── CONSTANTS ────────────────────────────────────────────────────────────────
const CITIES = [
  'Casablanca', 'Rabat', 'Meknès', 'Marrakech', 'Essaouira', 'Fès',
  'Tanger', 'Agadir', 'Al Hoceïma', 'Chefchaouen', 'Nador', 'Kénitra',
  'Asilah', 'Tétouan', 'Ifrane', 'Dakhla',
];

const HOTEL_TYPES = [
  'Hôtel', 'Riad', 'Resort', 'Auberge', "Maison d'hôte", 'Appartement', 'Camps dans le Désert',
];

const normalizeCity = (city) =>
  city.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

const normalizeType = (type) =>
  type.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

const SERVICES = [
  { value: "Wi-Fi gratuit", icon: <WifiIcon />, label: "Wi-Fi gratuit" },
  { value: "Parking", icon: <LocalParkingIcon />, label: "Parking" },
  { value: "Petit-déjeuner traditionnel inclus", icon: <FreeBreakfastIcon />, label: "Petit-déjeuner inclus" },
  { value: "Piscine intérieure/extérieure", icon: <PoolIcon />, label: "Piscine" },
  { value: "Hammam traditionnel marocain", icon: <ShowerIcon />, label: "Hammam marocain" },
  { value: "Spa et centre de bien-être", icon: <SpaIcon />, label: "Spa & bien-être" },
  { value: "Service de navette aéroport", icon: <AirportShuttleIcon />, label: "Navette aéroport" },
  { value: "Climatisation dans les chambres", icon: <AcUnitIcon />, label: "Climatisation" },
  { value: "Service en chambre 24h/24", icon: <RoomServiceIcon />, label: "Service en chambre 24h" },
  { value: "Réception 24h/24", icon: <RoomServiceIcon />, label: "Réception 24h" },
  { value: "Chambres familiales", icon: <FamilyRestroomIcon />, label: "Chambres familiales" },
  { value: "Terrasse panoramique", icon: <DeckIcon />, label: "Terrasse panoramique" },
  { value: "Restaurant avec cuisine marocaine", icon: <RestaurantIcon />, label: "Restaurant marocain" },
  { value: "Cuisine Marocaine", icon: <RestaurantIcon />, label: "Cuisine marocaine" },
  { value: "Personnel bilingue", icon: <LanguageIcon />, label: "Personnel bilingue" },
  { value: "Sécurité 24h/24", icon: <SecurityIcon />, label: "Sécurité 24h" },
  { value: "Service de ménage quotidien", icon: <CleaningServicesIcon />, label: "Ménage quotidien" },
  { value: "Coffre-fort", icon: <LockIcon />, label: "Coffre-fort" },
  { value: "Espaces non-fumeurs", icon: <SmokingRoomsIcon />, label: "Espaces non-fumeurs" },
  { value: "Jardin ou patio traditionnel", icon: <YardIcon />, label: "Jardin / Patio" },
  { value: "Service de location de voitures", icon: <DirectionsCarIcon />, label: "Location voitures" },
  { value: "Blanchisserie et nettoyage à sec", icon: <LocalLaundryServiceIcon />, label: "Blanchisserie" },
  { value: "Centre d'affaires / Wi-Fi haut débit", icon: <BusinessCenterIcon />, label: "Centre d'affaires" },
  { value: "Salle de réunion / conférence", icon: <MeetingRoomIcon />, label: "Salle de réunion" },
  { value: "Adapté aux personnes à mobilité réduite", icon: <AccessibleIcon />, label: "Accès mobilité réduite" },
  { value: "Réveil automatique / service de réveil", icon: <AlarmIcon />, label: "Service réveil" },
  { value: "Vue mer", icon: <WavesIcon />, label: "Vue mer" },
  { value: "Bibliothèque / Espace Lecture", icon: <LibraryBooksIcon />, label: "Bibliothèque" },
  { value: "Guide local privé", icon: <FollowTheSignsIcon />, label: "Guide local privé" },
];

// ─── COMPONENT ────────────────────────────────────────────────────────────────
const NewHotel = () => {
  const [info, setInfo] = useState({});
  const [services, setServices] = useState([]);
  const [logoUrl, setLogoUrl] = useState('');
  const [uploadingLogo, setUploadingLogo] = useState(false);
  const [bannerUrl, setBannerUrl] = useState('');
  const [uploadingBanner, setUploadingBanner] = useState(false);
  const [photosUrls, setPhotosUrls] = useState([]);
  const [uploadingPhotos, setUploadingPhotos] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [socials, setSocials] = useState({});
  const [mapEmbedUrl, setMapEmbedUrl] = useState('');
  const [menuLink, setMenuLink] = useState('');
  const [logoPreview, setLogoPreview] = useState(null);
  const [bannerPreview, setBannerPreview] = useState(null);
  const [featured, setFeatured] = useState(false);
  // ── Custom service builder ──
  const [customServices, setCustomServices] = useState([]);
  const [newServiceLabel, setNewServiceLabel] = useState('');
  const [newServiceIcon, setNewServiceIcon] = useState({ type: 'emoji', value: '⭐' });
  const [showPicker, setShowPicker] = useState(false);
  const [pickerTab, setPickerTab] = useState('mui');
  const [iconSearch, setIconSearch] = useState('');

  // ── MUI icon registry ─────────────────────────────────────────────────────
  const MUI_ICONS = {
    'LocalCafe': <LocalCafeIcon />,
    'BrunchDining': <BrunchDiningIcon />,
    'RestaurantMenu': <RestaurantMenuIcon />,
    'Restaurant': <RestaurantIcon />,
    'Kitchen': <KitchenIcon />,
    'Grass': <GrassIcon />,
    'NoMeals': <NoMealsIcon />,
    'Spa': <SpaIcon />,
    'EmojiFoodBeverage': <EmojiFoodBeverageIcon />,
    'SetMeal': <SetMealIcon />,
    'RamenDining': <RamenDiningIcon />,
    'LunchDining': <LunchDiningIcon />,
    'DinnerDining': <DinnerDiningIcon />,
    'Icecream': <IcecreamIcon />,
    'LocalBar': <LocalBarIcon />,
    'LocalPizza': <LocalPizzaIcon />,
    'BakeryDining': <BakeryDiningIcon />,
    'Tapas': <TapasIcon />,
    'FreeBreakfast': <FreeBreakfastIcon />,
    'Wifi': <WifiIcon />,
    'Tv': <TvIcon />,
    'AcUnit': <AcUnitIcon />,
    'Fireplace': <FireplaceIcon />,
    'Deck': <DeckIcon />,
    'Waves': <WavesIcon />,
    'Landscape': <LandscapeIcon />,
    'Pool': <PoolIcon />,
    'HotTub': <HotTubIcon />,
    'BeachAccess': <BeachAccessIcon />,
    'Cabin': <CabinIcon />,
    'Balcony': <BalconyIcon />,
    'Yard': <YardIcon />,
    'OutdoorGrill': <OutdoorGrillIcon />,
    'RoomService': <RoomServiceIcon />,
    'EventAvailable': <EventAvailableIcon />,
    'ShoppingBag': <ShoppingBagIcon />,
    'CreditCard': <CreditCardIcon />,
    'MeetingRoom': <MeetingRoomIcon />,
    'LocalPlay': <LocalPlayIcon />,
    'SupportAgent': <SupportAgentIcon />,
    'CleaningServices': <CleaningServicesIcon />,
    'Iron': <IronIcon />,
    'LocalLaundryService': <LocalLaundryServiceIcon />,
    'BusinessCenter': <BusinessCenterIcon />,
    'FitnessCenter': <FitnessCenterIcon />,
    'SelfImprovement': <SelfImprovementIcon />,
    'LocalParking': <LocalParkingIcon />,
    'DriveEta': <DriveEtaIcon />,
    'Accessible': <AccessibleIcon />,
    'SmokeFree': <SmokeFreeIcon />,
    'SmokingRooms': <SmokingRoomsIcon />,
    'DirectionsBus': <DirectionsBusIcon />,
    'ElectricCar': <ElectricCarIcon />,
    'TwoWheeler': <TwoWheelerIcon />,
    'AirportShuttle': <AirportShuttleIcon />,
    'MusicNote': <MusicNoteIcon />,
    'Piano': <PianoIcon />,
    'Casino': <CasinoIcon />,
    'SportsBar': <SportsBarIcon />,
    'SportsSoccer': <SportsSoccerIcon />,
    'GolfCourse': <GolfCourseIcon />,
    'Festival': <FestivalIcon />,
    'Celebration': <CelebrationIcon />,
    'ChildCare': <ChildCareIcon />,
    'FamilyRestroom': <FamilyRestroomIcon />,
    'Pets': <PetsIcon />,
    'Elderly': <ElderlyIcon />,
    'Groups': <GroupsIcon />,
    'Hotel': <HotelIcon />,
    'KingBed': <KingBedIcon />,
    'Bathtub': <BathtubIcon />,
    'Shower': <ShowerIcon />,
    'Elevator': <ElevatorIcon />,
    'VpnKey': <VpnKeyIcon />,
    'Luggage': <LuggageIcon />,
    'Nightlight': <NightlightIcon />,
    'Security': <SecurityIcon />,
    'CameraAlt': <CameraAltIcon />,
    'Star': <StarIcon />,
    'Verified': <VerifiedIcon />,
    'LocalOffer': <LocalOfferIcon />,
    'Language': <LanguageIcon />,
    'Brightness3': <Brightness3Icon />,
  };

  const QUICK_EMOJIS = [
    '⭐', '🍕', '🍔', '🥗', '🍜', '🍣', '🥩', '🍰', '☕', '🧃',
    '🍺', '🥂', '🍷', '🧁', '🥐', '🫕', '🍱', '🌮', '🥘', '🍝',
    '🎭', '🎵', '🎮', '📺', '🎪', '🌿', '🌊', '🏔️', '🌅', '🌙',
    '🚗', '🛵', '🚲', '✈️', '🗺️', '📍', '🔑', '💳', '📶', '🔒',
    '👶', '👴', '🐕', '♿', '🚭', '🅿️', '❄️', '🔥', '💡', '🌟',
    '💎', '🏆', '🎯', '✅', '🆕', '🔝', '💯', '🎁', '🛎️', '🏨',
  ];

  const filteredMuiIcons = Object.entries(MUI_ICONS).filter(([name]) =>
    name.toLowerCase().includes(iconSearch.toLowerCase())
  );

  const renderSelectedIcon = () => {
    if (newServiceIcon.type === 'emoji') return <span style={{ fontSize: 20 }}>{newServiceIcon.value}</span>;
    return <span style={{ display: 'flex', alignItems: 'center' }}>{MUI_ICONS[newServiceIcon.value]}</span>;
  };

  const renderCustomIcon = (icon) => {
    if (icon.type === 'emoji') return <span className="ncf-service-icon--emoji">{icon.value}</span>;
    return MUI_ICONS[icon.value] || <span>◆</span>;
  };

  // ── Handlers ──────────────────────────────────────────────────────────────
  const handleChange = (e) =>
    setInfo(prev => ({ ...prev, [e.target.id]: e.target.value }));

  const handleSocialsChange = (e) =>
    setSocials(prev => ({ ...prev, [e.target.id]: e.target.value }));

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setServices(prev => checked ? [...prev, value] : prev.filter(s => s !== value));
  };

  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setLogoPreview(URL.createObjectURL(file));
    setUploadingLogo(true);
    const fd = new FormData();
    fd.append('image', file);
    try {
      const res = await axios.post('https://api.moroccool.com/api/upload/image', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setLogoUrl(res.data.imageUrl + '?t=' + Date.now());
    } catch (err) { console.error(err); }
    finally { setUploadingLogo(false); }
  };

  const handleBannerUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setBannerPreview(URL.createObjectURL(file));
    setUploadingBanner(true);
    const fd = new FormData();
    fd.append('image', file);
    try {
      const res = await axios.post('https://api.moroccool.com/api/upload/image', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setBannerUrl(res.data.imageUrl + '?t=' + Date.now());
    } catch (err) { console.error(err); }
    finally { setUploadingBanner(false); }
  };

  const handlePhotosUpload = async (files) => {
    if (!files.length) return;
    setUploadingPhotos(true);
    try {
      for (const file of files) {
        const fd = new FormData();
        fd.append('image', file);
        const res = await axios.post('https://api.moroccool.com/api/upload/image', fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        setPhotosUrls(prev => [...prev, res.data.imageUrl]);
      }
    } catch (err) { console.error(err); }
    finally { setUploadingPhotos(false); }
  };

  const removePhoto = (url) =>
    setPhotosUrls(prev => prev.filter(p => p !== url));

  const addCustomService = () => {
    const label = newServiceLabel.trim();
    if (!label) return;
    const iconEncoded = `${newServiceIcon.type}:${newServiceIcon.value}`;
    const value = `custom_${Date.now()}_${label}|||${iconEncoded}`;
    setCustomServices(prev => [...prev, { value, label, icon: newServiceIcon }]);
    setServices(prev => [...prev, value]);
    setNewServiceLabel('');
    setNewServiceIcon({ type: 'emoji', value: '⭐' });
    setIconSearch('');
    setShowPicker(false);
  };

  const removeCustomService = (value) => {
    setCustomServices(prev => prev.filter(s => s.value !== value));
    setServices(prev => prev.filter(s => s !== value));
  };

  const dropzoneRef = createRef();
  const navigate = useNavigate();

  const handleClick = async (e) => {
    e.preventDefault();
    try {
      const newHotel = {
        ...info,
        services,
        logo: logoUrl,
        banner: bannerUrl,
        photos: photosUrls,
        socials,
        maps: mapEmbedUrl,
        menu: [menuLink],
        facebook: socials.facebook || '',
        instagram: socials.instagram || '',
        twitter: socials.x || '',
        tiktok: socials.tiktok || '',
        email: socials.email || '',
        website: socials.website || '',
        featured,
      };
      await axios.post('https://api.moroccool.com/api/hotels', newHotel);
      navigate('/hotels');
    } catch (err) {
      console.error(err);
    }
  };

  // ── Render ─────────────────────────────────────────────────────────────────
  return (
    <div className="ncf-studio">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />

      <div className="ncf-main">
        <Navbar />

        {/* ── HEADER ── */}
        <header className="ncf-header">
          <p className="ncf-header-eyebrow">Moroccool Dashboard</p>
          <h1 className="ncf-header-title">
            <strong>New</strong> Hotel or Riad
          </h1>
        </header>

        <div className="ncf-content">
          <form className="ncf-form" onSubmit={handleClick}>

            {/* ─── 01 · MEDIA ─────────────────────────────────────────────── */}
            <section className="ncf-section">
              <div className="ncf-section-head">
                <div className="ncf-section-meta">
                  <span className="ncf-section-num">01</span>
                  <h2 className="ncf-section-title">Visual Identity</h2>
                  <p className="ncf-section-desc">Logo, banner & gallery</p>
                </div>

                <div className="ncf-section-body">
                  <div className="ncf-upload-row">
                    {/* LOGO */}
                    <div className="ncf-upload-card">
                      <label className="ncf-label">Logo</label>
                      {logoPreview || logoUrl ? (
                        <div className="ncf-preview-wrap">
                          <img src={logoPreview || logoUrl} alt="logo" className="ncf-preview-logo" />
                          <button type="button" className="ncf-remove-btn"
                            onClick={() => { setLogoUrl(''); setLogoPreview(null); }}>
                            <CloseIcon />
                          </button>
                        </div>
                      ) : (
                        <label className="ncf-upload-zone" htmlFor="logo-input-hotel">
                          <input type="file" accept="image/*" id="logo-input-hotel" onChange={handleLogoUpload} />
                          <CloudUploadOutlinedIcon className="ncf-upload-icon" />
                          <span className="ncf-upload-text">Upload logo</span>
                          <span className="ncf-upload-sub">PNG, JPG · max 5 MB</span>
                        </label>
                      )}
                      {uploadingLogo && (
                        <div className="ncf-progress"><div className="ncf-progress-bar" /> Uploading…</div>
                      )}
                    </div>

                    {/* BANNER */}
                    <div className="ncf-upload-card">
                      <label className="ncf-label">Banner</label>
                      {bannerPreview || bannerUrl ? (
                        <div className="ncf-banner-wrap">
                          <img src={bannerPreview || bannerUrl} alt="banner" className="ncf-preview-banner" />
                          <button type="button" className="ncf-remove-btn"
                            onClick={() => { setBannerUrl(''); setBannerPreview(null); }}>
                            <CloseIcon />
                          </button>
                        </div>
                      ) : (
                        <label className="ncf-upload-zone" htmlFor="banner-input-hotel">
                          <input type="file" accept="image/*" id="banner-input-hotel" onChange={handleBannerUpload} />
                          <CloudUploadOutlinedIcon className="ncf-upload-icon" />
                          <span className="ncf-upload-text">Upload banner</span>
                          <span className="ncf-upload-sub">Recommended 1440 × 480 px</span>
                        </label>
                      )}
                      {uploadingBanner && (
                        <div className="ncf-progress"><div className="ncf-progress-bar" /> Uploading…</div>
                      )}
                    </div>
                  </div>

                  {/* GALLERY */}
                  <div className="ncf-field" style={{ marginTop: 24 }}>
                    <label className="ncf-label">Gallery</label>
                    <Dropzone
                      ref={dropzoneRef}
                      onDrop={handlePhotosUpload}
                      multiple
                      accept={{ 'image/*': [] }}
                      noClick
                      noKeyboard
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div {...getRootProps()} className="ncf-dropzone"
                          onClick={() => dropzoneRef.current?.open()}>
                          <input {...getInputProps()} />
                          <CloudUploadOutlinedIcon className="ncf-dropzone-icon" />
                          <p className="ncf-dropzone-title">Drop images or click to browse</p>
                          <p className="ncf-dropzone-sub">Upload multiple photos for the gallery</p>
                        </div>
                      )}
                    </Dropzone>

                    {uploadingPhotos && (
                      <div className="ncf-progress"><div className="ncf-progress-bar" /> Uploading photos…</div>
                    )}

                    {photosUrls.length > 0 && (
                      <div className="ncf-gallery">
                        {photosUrls.map((url, i) => (
                          <div key={`${url}-${i}`} className="ncf-gallery-item">
                            <img src={url} alt={`photo ${i + 1}`} className="ncf-gallery-img" />
                            <button type="button" className="ncf-remove-btn" onClick={() => removePhoto(url)}>
                              <CloseIcon />
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </section>

            {/* ─── 02 · INFO ──────────────────────────────────────────────── */}
            <section className="ncf-section">
              <div className="ncf-section-head">
                <div className="ncf-section-meta">
                  <span className="ncf-section-num">02</span>
                  <h2 className="ncf-section-title">General Info</h2>
                  <p className="ncf-section-desc">Name, city, type & description</p>
                </div>

                <div className="ncf-section-body">
                  <div className="ncf-input-grid">
                    {hotelInputs.map((input) => {
                      if (input.id === 'city') {
                        return (
                          <div className="ncf-field" key={input.id}>
                            <label className="ncf-label">{input.label}</label>
                            <select className="ncf-select" id="city"
                              value={info.city || ''} onChange={handleChange}>
                              <option value="">Select city</option>
                              {CITIES.map(c => (
                                <option key={c} value={normalizeCity(c)}>{c}</option>
                              ))}
                            </select>
                          </div>
                        );
                      }
                      if (input.id === 'type') {
                        return (
                          <div className="ncf-field" key={input.id}>
                            <label className="ncf-label">{input.label}</label>
                            <select className="ncf-select" id="type"
                              value={info.type || ''} onChange={handleChange}>
                              <option value="">Select type</option>
                              {HOTEL_TYPES.map(t => (
                                <option key={t} value={normalizeType(t)}>{t}</option>
                              ))}
                            </select>
                          </div>
                        );
                      }
                      return (
                        <div className="ncf-field" key={input.id}>
                          <label className="ncf-label">{input.label}</label>
                          <input className="ncf-input" type={input.type}
                            placeholder={input.placeholder} id={input.id}
                            value={info[input.id] || ''} onChange={handleChange} />
                        </div>
                      );
                    })}
                  </div>

                  <div className="ncf-field" style={{ marginTop: 20 }}>
                    <label className="ncf-label">Description</label>
                    <textarea className="ncf-textarea" id="description"
                      placeholder="Describe the atmosphere, amenities, what makes this place special…"
                      onChange={handleChange} />
                  </div>
                </div>
              </div>
            </section>

            {/* ─── 03 · LOCATION ──────────────────────────────────────────── */}
            <section className="ncf-section">
              <div className="ncf-section-head">
                <div className="ncf-section-meta">
                  <span className="ncf-section-num">03</span>
                  <h2 className="ncf-section-title">Location</h2>
                  <p className="ncf-section-desc">Google Maps embed</p>
                </div>
                <div className="ncf-section-body">
                  <div className="ncf-field">
                    <label className="ncf-label">Maps Embed URL</label>
                    <input className="ncf-input" type="text"
                      placeholder="https://www.google.com/maps/embed?pb=…"
                      value={mapEmbedUrl} onChange={(e) => {
                        let val = e.target.value.trim();
                        // Decode HTML entities (e.g. &#39; → ')
                        const txt = document.createElement('textarea');
                        txt.innerHTML = val;
                        val = txt.value;
                        setMapEmbedUrl(val);
                      }} />
                    <span className="ncf-helper">Paste the iframe src from Google Maps → Share → Embed</span>
                  </div>
                  {mapEmbedUrl && (
                    <div className="ncf-iframe-wrap">
                      <iframe src={mapEmbedUrl} allowFullScreen loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade" title="Map" />
                    </div>
                  )}
                </div>
              </div>
            </section>

            {/* ─── 04 · MENU ──────────────────────────────────────────────── */}
            <section className="ncf-section">
              <div className="ncf-section-head">
                <div className="ncf-section-meta">
                  <span className="ncf-section-num">04</span>
                  <h2 className="ncf-section-title">Digital Menu</h2>
                  <p className="ncf-section-desc">PDF or flipbook link</p>
                </div>
                <div className="ncf-section-body">
                  <div className="ncf-field">
                    <label className="ncf-label">Menu URL</label>
                    <input className="ncf-input" type="text"
                      placeholder="https://heyzine.com/flip-book/…"
                      value={menuLink} onChange={(e) => setMenuLink(e.target.value)} />
                  </div>
                  {menuLink && (
                    <div className="ncf-iframe-wrap ncf-iframe-wrap--menu">
                      <iframe src={menuLink} title="Menu" />
                    </div>
                  )}
                </div>
              </div>
            </section>

            {/* ─── 05 · SOCIALS ───────────────────────────────────────────── */}
            <section className="ncf-section">
              <div className="ncf-section-head">
                <div className="ncf-section-meta">
                  <span className="ncf-section-num">05</span>
                  <h2 className="ncf-section-title">Social & Contact</h2>
                  <p className="ncf-section-desc">Links & email</p>
                </div>
                <div className="ncf-section-body">
                  <div className="ncf-social-grid">
                    {[
                      { id: 'facebook', placeholder: 'Facebook URL', icon: <FacebookIcon className="ncf-social-icon ncf-social-icon--fb" /> },
                      { id: 'instagram', placeholder: 'Instagram URL', icon: <InstagramIcon className="ncf-social-icon ncf-social-icon--ig" /> },
                      { id: 'x', placeholder: 'Twitter (X) URL', icon: <TwitterIcon className="ncf-social-icon ncf-social-icon--tw" /> },
                      { id: 'website', placeholder: 'Website URL', icon: <PublicIcon className="ncf-social-icon ncf-social-icon--web" /> },
                      { id: 'email', placeholder: 'Contact Email', icon: <span className="ncf-social-icon ncf-social-icon--em">📧</span>, type: 'email' },
                      { id: 'tiktok', placeholder: 'TikTok URL', icon: <span className="ncf-social-icon ncf-social-icon--tt">🎵</span> },
                    ].map(({ id, placeholder, icon, type }) => (
                      <div className="ncf-social-row" key={id}>
                        {icon}
                        <input className="ncf-social-input" id={id} type={type || 'text'}
                          placeholder={placeholder} onChange={handleSocialsChange} />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </section>

            {/* ─── 06 · SERVICES ──────────────────────────────────────────── */}
            <section className="ncf-section">
              <div className="ncf-section-head">
                <div className="ncf-section-meta">
                  <span className="ncf-section-num">06</span>
                  <h2 className="ncf-section-title">Services & Amenities</h2>
                  <p className="ncf-section-desc">Select all that apply</p>
                </div>

                <div className="ncf-section-body">
                  <div className="ncf-services-grid">
                    {/* Preset services */}
                    {SERVICES.map((s) => (
                      <div key={s.value} className="ncf-service-item">
                        <input type="checkbox" id={`svc-${s.value}`} value={s.value}
                          checked={services.includes(s.value)} onChange={handleCheckboxChange} />
                        <label className="ncf-service-label" htmlFor={`svc-${s.value}`}>
                          <span className="ncf-service-icon">{s.icon}</span>
                          <span className="ncf-service-text">{s.label}</span>
                          <span className="ncf-service-check" />
                        </label>
                      </div>
                    ))}

                    {/* Custom services */}
                    {customServices.map((s) => (
                      <div key={s.value} className="ncf-service-item ncf-service-item--custom">
                        <input type="checkbox" id={`svc-${s.value}`} value={s.value}
                          checked={services.includes(s.value)} onChange={handleCheckboxChange} />
                        <label className="ncf-service-label" htmlFor={`svc-${s.value}`}>
                          <span className="ncf-service-icon">{renderCustomIcon(s.icon)}</span>
                          <span className="ncf-service-text">{s.label}</span>
                          <button type="button" className="ncf-service-remove"
                            onClick={(e) => { e.preventDefault(); removeCustomService(s.value); }}>
                            <CloseIcon />
                          </button>
                        </label>
                      </div>
                    ))}
                  </div>

                  {/* Add custom service */}
                  <div className="ncf-add-service">
                    <p className="ncf-add-service-title">Add a custom service</p>
                    <div className="ncf-add-service-row">

                      {/* Icon picker */}
                      <div className="ncf-emoji-wrap">
                        <button type="button" className="ncf-emoji-trigger"
                          onClick={() => setShowPicker(p => !p)}>
                          {renderSelectedIcon()}
                          <span className="ncf-emoji-caret">▾</span>
                        </button>

                        {showPicker && (
                          <div className="ncf-emoji-picker">
                            <div className="ncf-picker-tabs">
                              <button type="button"
                                className={`ncf-picker-tab${pickerTab === 'mui' ? ' ncf-picker-tab--active' : ''}`}
                                onClick={() => setPickerTab('mui')}>MUI Icons</button>
                              <button type="button"
                                className={`ncf-picker-tab${pickerTab === 'emoji' ? ' ncf-picker-tab--active' : ''}`}
                                onClick={() => setPickerTab('emoji')}>Emoji</button>
                            </div>

                            {pickerTab === 'mui' && (
                              <>
                                <input className="ncf-picker-search" type="text"
                                  placeholder="Search icons…" value={iconSearch}
                                  onChange={(e) => setIconSearch(e.target.value)} autoFocus />
                                <div className="ncf-mui-grid">
                                  {filteredMuiIcons.map(([name, component]) => (
                                    <button key={name} type="button" title={name}
                                      className={`ncf-mui-btn${newServiceIcon.type === 'mui' && newServiceIcon.value === name ? ' ncf-mui-btn--active' : ''}`}
                                      onClick={() => { setNewServiceIcon({ type: 'mui', value: name }); setShowPicker(false); }}>
                                      {component}
                                    </button>
                                  ))}
                                  {filteredMuiIcons.length === 0 && (
                                    <p className="ncf-picker-empty">No icons found</p>
                                  )}
                                </div>
                              </>
                            )}

                            {pickerTab === 'emoji' && (
                              <div className="ncf-emoji-grid">
                                {QUICK_EMOJIS.map((em) => (
                                  <button key={em} type="button"
                                    className={`ncf-emoji-btn${newServiceIcon.type === 'emoji' && newServiceIcon.value === em ? ' ncf-emoji-btn--active' : ''}`}
                                    onClick={() => { setNewServiceIcon({ type: 'emoji', value: em }); setShowPicker(false); }}>
                                    {em}
                                  </button>
                                ))}
                              </div>
                            )}
                          </div>
                        )}
                      </div>

                      <input className="ncf-input ncf-add-service-input" type="text"
                        placeholder="Service name (e.g. Rooftop pool)"
                        value={newServiceLabel}
                        onChange={(e) => setNewServiceLabel(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), addCustomService())} />

                      <button type="button" className="ncf-btn-add-service" onClick={addCustomService}>
                        + Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* ─── 07 · LISTING ───────────────────────────────────────────── */}
            <section className="ncf-section">
              <div className="ncf-section-head">
                <div className="ncf-section-meta">
                  <span className="ncf-section-num">07</span>
                  <h2 className="ncf-section-title">Listing Type</h2>
                  <p className="ncf-section-desc">Choose visibility level</p>
                </div>
                <div className="ncf-section-body">
                  <div className="ncf-listing-tabs">
                    <div className={`ncf-listing-tab${!featured ? ' ncf-listing-tab--active' : ''}`}
                      onClick={() => setFeatured(false)}>
                      <div className="ncf-tab-title">Standard</div>
                      <div className="ncf-tab-desc">Regular listing in search results</div>
                    </div>
                    <div className={`ncf-listing-tab${featured ? ' ncf-listing-tab--active' : ''}`}
                      onClick={() => setFeatured(true)}>
                      <div className="ncf-tab-title">Featured ✦</div>
                      <div className="ncf-tab-desc">Highlighted at the top of results</div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* ─── SUBMIT ─────────────────────────────────────────────────── */}
            <div className="ncf-submit-zone">
              <p className="ncf-submit-note">All fields marked are required before publishing.</p>
              <button type="submit" className="ncf-btn-submit">
                <CheckCircleOutlineIcon />
                Create Hotel Listing
                <ArrowForwardIcon />
              </button>
            </div>

          </form>
        </div>

        <footer className="ncf-footer">
          © {new Date().getFullYear()} <span>Moroccool</span> — All rights reserved.
        </footer>
      </div>
    </div>
  );
};

export default NewHotel;